// extracted by mini-css-extract-plugin
export default {"sib-naos-scrollbar":"lzxUEqVaWhnF7AKEloqE"};